import { Card } from 'antd';
import styled from 'styled-components';

export const DetailsCard = styled(Card)`
  margin-top: 12px;
  border: none;
`;
